module.exports = __webpack_public_path__ + "img/Our_Inn_Place@1x.a9b08728.webp";